module.exports = __webpack_public_path__ + "static/img/wantedLow.4fc5ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wantedLow.png
// module id = +rMF
// module chunks = 1 3